import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "./locales/pt/common.json";
import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";

import ptDashboard from "./locales/pt/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import esDashboard from "./locales/es/dashboard.json";

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        pt: {
          common: ptCommon,
          dashboard: ptDashboard,
        },
        en: {
          common: enCommon,
          dashboard: enDashboard,
        },
        es: {
          common: esCommon,
          dashboard: esDashboard,
        },
      },

      fallbackLng: "pt",
      supportedLngs: ["pt", "en", "es"],
      nonExplicitSupportedLngs: true,

      ns: ["common", "dashboard", "settings"],
      defaultNS: "common",

      keySeparator: ".",

      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        caches: ["localStorage"],
      },

      interpolation: {
        escapeValue: false,
      },

      react: {
        useSuspense: false,
      },

      returnNull: false,
      returnEmptyString: false,

      debug: false,
    });
}

export default i18n;
